import { z } from "zod";
const attributesEmbedSchema = z.object({
  src: z.string(),
  caption: z.string().default("").optional(),
  alt: z.string().default("")
});
export {
  attributesEmbedSchema
};
//# sourceMappingURL=attributes.js.map
